export const apiConfig = {
    powerPointEndPoint: ''
}

export const msalConfig = {
    clientId: '4294e906-8e49-4242-8530-3aafece83dfa'
}

export const envConfig = {
    envName: '[Dev]'
}
